import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {MarkaModel} from '../model/spring-model/marka.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class MarkaService {

  constructor(private https: HttpClient, private  authService: AuthenticationService) { }

  getMarkaListS(): Observable<HttpResponse<MarkaModel[]>> {
      const apiURL = AppConstants.API_ENDPOINT_SPRING + 'marka';
    return this.https.get<MarkaModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/marka.service.ts